module.exports = __webpack_public_path__ + "assets/img/0f6f-li.svg";